export default __webpack_public_path__ + "static/media/svg-7.4f2997d2.svg";